<div class="container">
    <div style="text-align:center;word-wrap:break-word;">
        <h1>Willkommen bei {{ title }}</h1>
    </div>
	<app-header></app-header>
    <router-outlet></router-outlet>
</div>
